import React from "react";
import RoomCard from "./RoomCard";
import { useTranslation } from "react-i18next";
import {
  phongNghi,
  phongPrice280,
  phongPrice280_h1,
  phongPrice280_h2,
  phongPrice280_h3,
  phongPrice280_h4,
  phongPrice300,
  phongPrice300_h1,
  phongPrice300_h2,
  phongPrice300_h3,
  phongPrice300_h4,
  phongPrice350,
  phongPrice350_h1,
  phongPrice350_h2,
  phongPrice350_h3,
  phongPrice350_h4,
  phongPrice350_h5,
  phongPrice400,
  phongPrice400_h1,
  phongPrice400_h2,
  phongPrice400_h3,
  phongPrice400_h4,
  phongPrice500,
  phongPrice500_h1,
  phongPrice500_h2,
  phongPrice500_h3,
  phongPrice500_h4,
  phongPrice550,
  phongPrice550_h1,
  phongPrice550_h2,
  phongPrice550_h3,
  phongPrice550_h4,
} from "../assets/images";
export const rooms = [
  {
    type: 1,
    title: "Double Standard",
    price: "280.000 VND",
    header: "Double Standard - 1 giường đôi",
    header1: "Đế Vương Hotel TRẢI NGHIỆM CUỘC SỐNG ĐẲNG CẤP",
    dientich: "16m2",
    amenities: [
      "1 giường 160x200cm",
      "Điều hòa không khí",
      "Tủ lạnh",
      "Điện thoại",
      "Tủ quần áo",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
    ],
    content:
      "Hạng phòng sở hữu không gian riêng biệt giúp Quý khách thoải mái nghỉ ngơi giữa không gian riêng tư, yên tĩnh.",
    image: [
      phongPrice280,
      phongPrice280_h1,
      phongPrice280_h2,
      phongPrice280_h3,
      phongPrice280_h4,
    ],
  },
  {
    type: 2,
    title: "Double Premium",
    price: "300.000 VND",
    header1: "ĐẦY TINH TẾ – TRỌN TIỆN NGHI",
    dientich: "18m2",
    amenities: [
      "1 giường 160x200cm",
      "Điều hòa không khí",
      "View thành phố ",
      "Tủ lạnh",
      "Điện thoại",
      "Tủ quần áo",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
      "Smart tivi",
    ],
    content:
      "Bạn có thể đón ánh hoàng hôn chiều tà ngay trong căn phòng của chính mình và tổng kết lại những gì đã đạt được trong một ngày dài.",
    header: "Double Premium - 1 giường đôi",
    image: [
      phongPrice300,
      phongPrice300_h1,
      phongPrice300_h2,
      phongPrice300_h3,
      phongPrice300_h4,
    ],
  },
  {
    type: 3,
    title: "Double Twin",
    price: "350.000 VND",
    dientich: "18m2",
    header: "Double Twin - 2 giường đơn",
    header1: "ĐẦY TINH TẾ – TRỌN TIỆN NGHI",
    amenities: [
      "1 giường 160x200cm",
      "Điều hòa không khí",
      "Tủ lạnh",
      "Điện thoại",
      "Tủ quần áo",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
    ],
    content:
      "Chuyến công tác sẽ thật hiệu quả nếu hôm trước bạn nghỉ ngơi thật thoải mái mà không bị ai làm phiền. Vừa tiết kiệm lại được sự thoải mái trong giấc ngủ, tại sao bạn không lựa chọn hạng phòng này nhỉ?",
    image: [
      phongPrice350,
      phongPrice350_h1,
      phongPrice350_h2,
      phongPrice350_h3,
      phongPrice350_h4,
      phongPrice350_h5,
    ],
  },
  {
    type: 4,
    title: "Triple Deluxe ",
    price: "400.000 VND",
    dientich: "25m2",
    header: "Triple Deluxe - 1 giường đôi và 1 giường đơn",
    header1: "ĐẦY TINH TẾ – TRỌN TIỆN NGHI",
    amenities: [
      "1 giường 160x200cm và 1 giường 120x200cm",
      "View đường phố",
      "Điều hòa không khí",
      "Tủ lạnh",
      "Điện thoại",
      "Tủ quần áo",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
    ],
    content:
      "Hạng phòng dành cho Quý khách muốn đón ánh bình minh chào ngày mới thật nhiều năng lượng hay chỉ muốn nằm trên giường êm ả hòa mình cùng ánh nắng mai nhẹ nhàng…",
    image: [
      phongPrice400,
      phongPrice400_h1,
      phongPrice400_h2,
      phongPrice400_h3,
      phongPrice400_h4,
    ],
  },
  {
    type: 5,
    title: "Double-double Standard",
    price: "500.000 VND",
    dientich: "26m2",
    header: "Double-double Standard - 2 giường đôi",
    header1: "ĐẦY TINH TẾ – TRỌN TIỆN NGHI",
    amenities: [
      "2 giường 160x200cm",
      "Điều hòa không khí",
      "Tủ lạnh",
      "Điện thoại",
      "Tủ quần áo",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
    ],
    content:
      "Hạng phòng view nhìn thành phố này bạn có thể cùng nhóm bạn hay những người thân trong gia đình ngắm nhìn thành phố Cao Lãnh ",
    image: [
      phongPrice500,
      phongPrice500_h1,
      phongPrice500_h2,
      phongPrice500_h3,
      phongPrice500_h4,
    ],
  },
  {
    type: 6,
    title: "Double-double Premium",
    price: "550.000 VND",
    dientich: "32m2",
    amenities: [
      "2 giường 160x200cm",
      "View thành phố",
      "Điều hòa không khí",
      "Tủ lạnh",
      "Bộ sofa",
      "Điện thoại",
      "Tủ quần áo",
      "Bàn làm việc",
      "Bàn trang điểm",
      "Ấm đun nước điện",
      "Dịch vụ giặt ủi",
      "Phòng tắm riêng",
      "Vòi sen",
      "Smart tivi",
    ],
    content:
      "Với các Quý khách yêu thích sự thoáng đãng, rộng rãi, đầy đủ tiện nghi như chính ngôi nhà của mình thì đây quả thật là một chọn lựa không thể bỏ qua khi đến với Đế Vương Hotel – Be your home!",
    header: "Double-double Premium - 2 giường đôi",
    header1: "ĐẦY TINH TẾ – TRỌN TIỆN NGHI",
    image: [
      phongPrice550,
      phongPrice550_h3,
      phongPrice550_h1,
      phongPrice550_h2,
      phongPrice550_h4,
    ],
  },
];
const Rooms = () => {
  const { t, i18n } = useTranslation();

  return (
    <section className="py-[10px]">
      <div className="relative mb-8 h-[400px]">
        <img
          src={phongNghi}
          alt={t("HOTEL_LOBBY")}
          className="w-full absolute top-0 left-0 right-0 h-[400px] object-cover rounded-lg shadow-lg"
        />
        <div className="bg-black absolute z-10 w-full h-full opacity-10 rounded"></div>
      </div>
      <h2 className="text-[18px] font-[500] text-left font-cormorant">
        {t("ROOMS")}
      </h2>
      <p className="bg-gray-400 h-[1px] my-[9px]"></p>
      <div className="my-[20px] items-center text-center">
        <h4 className="text-[#fbbe17] font-cormorant text-[35px] font-light">
          {t("FEATURED")}
        </h4>
        <h1 className="text-[22px] font-cormorant">{t("HOTEL_ROOMS")}</h1>
        <p className="font-greatVibes text-gray-500 text-[17px] my-[10px] lg:mx-[150px] ssx:mx-[20px]">
          {t("ROOM_DESCRIPTION")}
        </p>
        <div className="flex gap-[15px] justify-center my-[10px]">
          <button className="bg-gray-300 text-[14px] text-black px-4 py-2 rounded">
            {t("VIEW_DETAILS")}
          </button>
          <button className="bg-[#fbbe17] text-[14px] text-black px-4 py-2 rounded ml-4">
            {t("BOOK_NOW")}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-[30px]">
        {rooms.map((room, index) => (
          <RoomCard
            key={index}
            code={room.type}
            title={t(room.title)}
            price={room.price}
            image={room.image}
          />
        ))}
      </div>
    </section>
  );
};

export default Rooms;
